import Ajax from '@/assets/js/request'
import c from '@/assets/js/config'

const store = {
  state: {
    userInfo: null,
    selectUserInfo: null,
  },
  actions: {
    // 获取用户信息
    async getUserInfo({ commit }) {
      const userInfo = await Ajax('/inner/account/userInfo')
      if (userInfo.admin !== 1) {
        localStorage.setItem(`${c.Storage}selectUser`, userInfo._id)
        commit('getSelectUserInfo', userInfo)
      }
      commit('getUserInfo', userInfo)
    },
    async getSelectUserInfo({ commit }) {
      const userInfo = await Ajax('/inner/account/userInfo', {
        _id: localStorage.getItem(`${c.Storage}selectUser`),
      })
      commit('getSelectUserInfo', userInfo)
    },
    logout({ commit }) {
      commit('logout')
    },
  },
  mutations: {
    getUserInfo(state, value) {
      state.userInfo = value
    },
    getSelectUserInfo(state, value) {
      state.selectUserInfo = value
    },
    logout(state) {
      state.userInfo = null
      state.selectUserInfo = null
    },
  },
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js